export default __webpack_public_path__ + "static/media/srch-off-nav-white.2b05c042.svg";